var defaultStyles = function defaultStyles(_ref) {
  var colors = _ref.colors,
      fonts = _ref.fonts;
  return {
    container: {
      width: '100%'
    },
    root: {
      padding: '5px 24px 0'
    },
    stepIcon: {
      marginTop: 6,
      minWidth: 12,
      minHeight: 12,
      borderRadius: '50%',
      color: colors.white,
      '& svg': {
        display: 'block',
        fontSize: 6,
        margin: '3px auto 0'
      }
    },
    stepIconDefault: {
      border: "".concat(colors.ultraLightGrey, " solid 1px"),
      backgroundColor: colors.white
    },
    stepIconDanger: {
      backgroundColor: colors.errorRed
    },
    stepIconSuccess: {
      backgroundColor: colors.nikeFuel
    },
    stepIconWarning: {
      backgroundColor: colors.laserOrange
    },
    label: {
      fontSize: 9,
      fontFamily: fonts["default"],
      textTransform: 'uppercase',
      color: fonts.mediumGrey,
      marginTop: '5px!important'
    },
    activeLabel: {
      color: fonts.mediumGrey
    }
  };
};

export default defaultStyles;